<template>
  <div class="home container" :class="{dark: darkmode}">
    <div class="header">
      <div class="user">
        <div class="avatar">
          <img src="@/assets/images/avatar.jpg" alt="">
        </div>
        <div class="nickname">Edith.hsu</div>
      </div>
      <div class="search">
        <el-input
          placeholder="搜尋"
          v-model="searchText">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="mode" @click="toggleDarkmode">
        <img :src="require(`@/assets/images/${mode}mode.svg`)" alt="">
      </div>
    </div>
    <div class="notes-container">
      <div class="functions">
        <div class="show-star" @click="starOnly = !starOnly">
          <div v-if="!darkmode" class="img-container">
            <img v-if="starOnly" src="@/assets/images/star-regular.svg" alt="">
            <img v-else src="@/assets/images/star-solid.svg" alt="">
          </div>
          <div v-else class="img-container">
            <img v-if="starOnly" src="@/assets/images/star-regular-dark.svg" alt="">
            <img v-else src="@/assets/images/star-solid-dark.svg" alt="">
          </div>
          <span>{{ starOnly ? '顯示全部筆記' : '顯示星號筆記'}}</span>
        </div>
        <div class="display-mode">
          <div class="list-mode" @click="cardmode = false">
            <img v-show="!cardmode" :src="require(`@/assets/images/list-${mode}.svg`)" alt="">
            <img v-show="cardmode" :src="require(`@/assets/images/list-inactive.svg`)" alt="">
          </div>
          <div class="card-mode" @click="cardmode = true">
            <img v-show="cardmode" :src="require(`@/assets/images/card-${mode}.svg`)" alt="">
            <img v-show="!cardmode" :src="require(`@/assets/images/card-inactive.svg`)" alt="">
          </div>
        </div>
      </div>
      <div class="notes" :class="{'card-mode': cardmode, 'list-mode': !cardmode}">
        <el-card class="cards">
          <div class="add-note" :class="{card: cardmode, list: !cardmode}"  @click="addNote">
            <div class="plus-wrap">
              <img :src="require(`@/assets/images/plus-${mode}.svg`)" alt="">
            </div>
            <span>新增筆記</span>
          </div>
        </el-card>
        <el-card v-show="cardmode && (!starOnly || note.star)" v-for="(note, i) in notes" :key="`card-${i}`" class="cards" :style="renderBackgroundImage(note.cover)">
          <div :class="{card: cardmode, list: !cardmode}">
            <div class="title">{{note.title}}</div>
            <div class="star" @click="note.star = !note.star">
              <img v-if="note.star" src="@/assets/images/star-solid.svg" alt="">
              <img v-else src="@/assets/images/star-regular.svg" alt="">
            </div>
          </div>
        </el-card>
        <el-card v-show="!cardmode && (!starOnly || note.star)" v-for="(note, i) in notes" :key="`list-${i}`" class="cards list-mode">
          <div :class="{card: cardmode, list: !cardmode}">
            <div class="title">{{note.title}}</div>
            <div v-if="!darkmode" class="star" @click="note.star = !note.star">
              <img v-if="note.star" src="@/assets/images/star-solid.svg" alt="">
              <img v-else src="@/assets/images/star-regular.svg" alt="">
            </div>
            <div v-else class="star" @click="note.star = !note.star">
              <img v-if="note.star" src="@/assets/images/star-solid-dark.svg" alt="">
              <img v-else src="@/assets/images/star-regular-dark.svg" alt="">
            </div>
          </div>
        </el-card>
        <div
          v-show="cardmode"
          v-for="i in Math.ceil(notes.length / 4)"
          :key="`row-decoration-${i}`"
          :style="{top: 216 + (i - 1) * 336 + 'px'}"
          class="row-decoration"
        >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import * as cover from '@/assets/images/cover/'
console.log(cover)
export default {
  name: 'home',
  data() {
    return {
      total: 10,
      searchText: '',
      starOnly: false,
      // darkmode: false,
      cardmode: true, // card / list
      notes: [
        {
          cover: 'cover1',
          title: 'qwertlifojeojfjwfjowowjidjoqjy',
          star: false
        },
        {
          cover: 'cover2',
          title: 'asdfg',
          star: true
        },
        {
          cover: 'cover3',
          title: 'zxcvbn',
          star: false
        }
      ]
    }
  },
  computed: {
    mode() {
      return this.darkmode ? 'dark' : 'light'
    },
    darkmode() {
      return this.$store.getters.darkmode
    }
  },
  methods: {
    renderBackgroundImage(covertype) {
      return {
        backgroundImage: `url(${cover[covertype]})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center, center'
      }
    },
    addNote() {
      this.$notify({
        title: '未完成',
        message: '近期推出',
        type: 'warning'
      })
    },
    toggleDarkmode() {
      this.$store.dispatch('toggleDarkmode')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/app.scss';
img {
  width: 100%;
}
.home {
  &.dark {
    background-color: #22222D;
    .header {
      .user .nickname {
        color: #fff;
      }
      .search .el-input input {
        // width: 35%;
        background-color: #444;
      }
    }
    .notes-container {
      .functions {
        .show-star {
          background-color: #424255;
          color: #fff;
        }
      }
      .notes {
        .cards {
          background-color: #22222D;
          .add-note {
            background-color: transparent;
            color: #fff;
          }
        }
        .el-card.cards.list-mode {
          background-color: #454558;
          color: #fff;
        }
      }
    }
  }
  .header {
    @extend %flexbox;
    @include justify-content(space-between);
    @include align-items(center);
    margin: 16px 0;
    height: 50px;
    .user {
      @extend %flexbox;
      @include justify-content(flex-start);
      @include align-items(center);
      .avatar {
        img {
          border-radius: 50%;
        }
      }
      .nickname {
        margin-left: 20px;
      }
    }
    .user .avatar img,
    .mode {
      width: 40px;
      height: 40px;
      cursor: pointer;
    }
    .search {
      width: 35%;
    }
  }
  .notes-container {
    .functions {
      @extend %flexbox;
      @include justify-content(space-between);
      @include align-items(center);
      .show-star {
        @extend %flexbox;
        @include justify-content(space-between);
        @include align-items(center);
        width: auto;
        height: 38px;
        padding: 0 16px;
        background-color: #eee;
        border-radius: 5px;
        cursor: pointer;
        .img-container {
          width: 20px;
          margin-right: 10px;
        }
      }
      .display-mode {
        @extend %flexbox;
        @include justify-content(space-between);
        @include align-items(center);
        .card-mode,
        .list-mode {
          width: 40px;
          height: 40px;
          padding: 5px;
          cursor: pointer;
        }
      }
    }
    .notes {
      position: relative;
      margin: 40px 0;
      @include display-grid;
      @include column-gap(30px);
      .el-card.cards.list-mode {
        background-color: #f4f4f4;
      }
      &.card-mode {
        @include grid-template-columns(grid-repeat(4, 1fr));
        @include row-gap(80px);
      }
      &.list-mode {
        @include grid-template-columns(grid-repeat(2, 1fr));
        @include row-gap(30px);
      }
      .cards {
        will-change: height;
        transition: height 1s ease;
        z-index: 100;
        border-radius: 10px;
        .card,
        .list {
          height: 216px;
          @extend %flexbox;
          @include flex-direction(column);
          @include justify-content(space-between);
          @include align-items(center);
          .title {
            @include align-self(flex-start);
            word-break: break-word;
            text-align: left;
          }
          .star {
            height: 25px;
            text-align: left;
            @include align-self(flex-start);
            cursor: pointer;
            img {
              height: 100%;
              width: auto;
            }
          }
        }
        .card {
          &:before {
            // content: '';
            // position: absolute;
            // top: 0;
            // left: 0;
            // right: 0;
            // bottom: 0;
            // background-color: rgba(#fff, .5);
          }
        }
        .list {
          @include flex-direction(row);
          @include justify-content(space-between);
          height: 20px;
          .star {
            height: 20px;
          }
        }
        .add-note {
          @include justify-content(center);
          background-color: rgba(#fff, .5);
          cursor: pointer;
          .plus-wrap {
            width: 30px;
          }
          &.list {
            @include flex-direction(row-reverse);
            @include justify-content(space-between);
            height: 20px;
            .plus-wrap {
              width: 20px;
            }
          }
        }
      }
      .row-decoration {
        position: absolute;
        width: 100%;
        height: 80px;
        background: linear-gradient(to bottom, #F1F0F0, #F5F5F5);
        width: 110%;
        left: -5%;
        transform: skew(-25deg);
      }
    }
  }
}
</style>

<style lang="scss">
.el-input {
  input {
    border-radius: 20px;
  }
}
.home {
  &.dark {
    .header {
      .search .el-input input {
        background-color: #22222D;
      }
    }
  }
}
</style>